package com.vizio.redwolf.pay.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 * Reference: https://github.com/BuddyTV/vizio-models/blob/master/development/sdk/redwolf/IdentityGraph.kt
 *
 * Note: Kotlin data class inheritance does not work well and is not recommended:
 * https://discuss.kotlinlang.org/t/data-classes-should-be-able-to-inherit-from-each-other/4496
 * Hence, there is a lot of dupe code below
 */
@Serializable
@JsExport
data class BillingAddress(
    @SerialName("postalCode") val postalCode: String,
    @SerialName("firstName") val firstName: String? = null,
    @SerialName("lastName") val lastName: String? = null,
    @SerialName("streetAddress") val streetAddress: String? = null,
    @SerialName("additionalAddress") val additionalAddress: String? = null,
    @SerialName("city") val city: String? = null,
    @SerialName("state") val state: String? = null,
)

@Serializable
@JsExport
data class InvoiceAddress(
    @SerialName("postalCode") val postalCode: String,
    @SerialName("firstName") val firstName: String? = null,
    @SerialName("lastName") val lastName: String? = null,
    @SerialName("street") val street: String? = null,
    @SerialName("city") val city: String? = null,
    @SerialName("state") val state: String? = null,
)

@Serializable
data class CompanyAddress(
    @SerialName("postalCode") val postalCode: String,
    @SerialName("companyName") val companyName: String? = null,
    @SerialName("street") val street: String? = null,
    @SerialName("city") val city: String? = null,
    @SerialName("state") val state: String? = null,
)

@Serializable
@JsExport
data class CartAddress(
    val firstName: String?,
    val lastName: String?,
    val streetAddress: String?,
    val additionalAddress: String? = null,
    val city: String?,
    val state: String?,
    val postalCode: String,
    val phone: String?,
)
